// extracted by mini-css-extract-plugin
export var legendIndicator = "_gk-1";
export var legendRight = "_gk-0";